module.exports = __webpack_public_path__ + "img/avatar3.32bdb9f6.png";